import React from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Divider } from '@material-ui/core';
import { Litros, Reais } from '../../components/numberUtils';
import { VendaBico } from '../../models/venda';

export const ListItemBico = (props: VendaBico) => {
  return <div key={props.bico}>
    <ListItem>
      <ListItemAvatar>
        <Avatar style={{ backgroundColor: 'orange' }}>
          {props.bico.toString()}
        </Avatar>
      </ListItemAvatar>
      <ListItemText secondary={<><span>{props.produtoNome}</span><span style={{ display: 'block' }}>EI:{props.menorEncerrante}</span></>}>
        <span> <Litros valor={props.quantidade} /> </span>
      </ListItemText>
      <ListItemText style={{ textAlign: 'right' }} secondary={<><span>{props.contagem} venda(s)</span><span style={{ display: 'block' }}>EF:{props.maiorEncerrante}</span></>}>
        <b style={{ fontSize: '1.1rem' }}><Reais valor={props.total} />  </b>
      </ListItemText>
    </ListItem>
    <Divider />
  </div>;
};